import React from 'react';
import styles from './styles/licenseTable.module.css';

const LicenseTable = () => {
  return (
    <table className={styles.licenseTable}>
      <thead>
        <tr>
          <th>License</th>
          <th>Number</th>
          <th>Expiration</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Guard Card</td>
          <td>123456</td>
          <td>2026-01-01</td>
        </tr>
        <tr>
          <td>Firearms Permit</td>
          <td>789012</td>
          <td>2025-11-12</td>
        </tr>
      </tbody>
    </table>
  );
};

export default LicenseTable;
